import React from 'react';
import { Slider } from 'ceci-ui'
import { Container } from './styles';

const CollectionRuleForm = () => {
  return (
    <Container>
      <h3>Régua de cobrança</h3>
      <p>Aceitar pagamento até quantos dias após o vencimento?</p>
      <Slider />
      <p>Qual régua de cobrança é mais adequada?</p>
      <ul>
        <li>
          <span>notifications_paused</span>
          <h4>Mudo</h4>
          <p>Nenhuma notificação é enviada.</p>
        </li>
        <li>
          <span>highlight</span>
          <h4>Inteligente</h4>
          <p>As melhores práticas para receber no prazo e nutrir um bom relacionamento.</p>
        </li>
        <li>
          <span>gavel</span>
          <h4>Transacional</h4>
          <p>Uma única notificação é enviada na emissão da cobrança.</p>
        </li>
        <li>
          <span>compare_arrows</span>
          <h4>Opcional</h4>
          <p>Lembretes de notificação até o vencimento.</p>
        </li>
        <li>
          <span>notification_important</span>
          <h4>Agressiva</h4>
          <p>Régua contínua de cobranças com um forte apelo pós-vencimento.</p>
        </li>
      </ul>
    </Container>
  );
};

export default CollectionRuleForm;
